import { atom } from "jotai";

interface ModalOriginPosition {
  x: number;
  y: number;
}

export const modalOriginPositionAtom = atom<ModalOriginPosition | null>(null);
modalOriginPositionAtom.debugLabel = "modalOriginPositionAtom";
